<div class="maintenance-container">
  <div class="maintenance-topbar">
    <div class="topbar-left">
      <h1>
        Maintenance Jobs
        <small>Manage equipment maintenance and repair tasks</small>
      </h1>
      <div class="breadcrumb">
        <i class="bi bi-house-door"></i> IMS / <span>Maintenance</span> / <span class="current">Maintenance Jobs</span>
        <span class="separator">|</span>
        <span class="time"><i class="bi bi-clock"></i> {{ timestamp }}</span>
      </div>
    </div>
    <div class="topbar-right">
      <div class="search-box">
        <i class="bi bi-search"></i>
        <input type="text" placeholder="Search maintenance jobs..." [ngModel]="searchQuery()" (ngModelChange)="searchQuery.set($event)" />
      </div>
      <button class="btn btn-outline btn-sm" (click)="exportData()">
        <i class="bi bi-download"></i> Export
      </button>
      <button class="btn btn-primary" (click)="openJobModal()">
        <i class="bi bi-plus-circle"></i> New Job
      </button>
    </div>
  </div>

  <div class="stats-row">
    <div class="stat-card">
      <div class="stat-icon blue">
        <i class="bi bi-wrench"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Total Jobs</div>
        <div class="stat-value">{{ jobStats().totalJobs }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon amber">
        <i class="bi bi-clock"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">In Progress</div>
        <div class="stat-value">{{ jobStats().inProgress }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon green">
        <i class="bi bi-check-circle"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Completed</div>
        <div class="stat-value">{{ jobStats().completed }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon red">
        <i class="bi bi-exclamation-circle"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Pending</div>
        <div class="stat-value">{{ jobStats().pending }}</div>
      </div>
    </div>
  </div>

  <div class="filter-bar">
    <div class="filter-left">
      <div class="filter-group">
        <label><i class="bi bi-tag"></i> Status</label>
        <select [ngModel]="statusFilter()" (ngModelChange)="statusFilter.set($event)">
          <option value="">All Status</option>
          <option value="pending">Pending</option>
          <option value="in-progress">In Progress</option>
          <option value="on-hold">On Hold</option>
          <option value="completed">Completed</option>
          <option value="cancelled">Cancelled</option>
        </select>
      </div>
      <div class="filter-group">
        <label><i class="bi bi-tools"></i> Type</label>
        <select [ngModel]="typeFilter()" (ngModelChange)="typeFilter.set($event)">
          <option value="">All Types</option>
          <option value="repair">Repair</option>
          <option value="maintenance">Maintenance</option>
          <option value="inspection">Inspection</option>
          <option value="service">Service</option>
        </select>
      </div>
    </div>
    <div class="filter-right">
      <span class="filter-count">Showing {{ filteredJobs().length }} jobs</span>
      <button
        type="button"
        class="btn btn-outline btn-sm"
        [class.active]="showMoreFilters()"
        (click)="toggleMoreFilters()"
      >
        <i class="bi bi-funnel"></i> More Filters
      </button>
    </div>
  </div>

  @if (showMoreFilters()) {
    <div class="filter-bar filter-bar-advanced">
      <div class="filter-left">
        <div class="filter-group">
          <label><i class="bi bi-flag"></i> Priority</label>
          <select [ngModel]="priorityFilter()" (ngModelChange)="priorityFilter.set($event)">
            <option value="">All Priorities</option>
            <option value="critical">Critical</option>
            <option value="high">High</option>
            <option value="medium">Medium</option>
            <option value="low">Low</option>
          </select>
        </div>
        <div class="filter-group">
          <label><i class="bi bi-person"></i> Assigned To</label>
          <input
            type="text"
            placeholder="Search assignee..."
            [ngModel]="assignedToFilter()"
            (ngModelChange)="assignedToFilter.set($event)"
          />
        </div>
      </div>
      <div class="filter-right">
        <button type="button" class="btn btn-outline btn-sm" (click)="clearMoreFilters()">
          Clear advanced filters
        </button>
      </div>
    </div>
  }

  <div class="table-wrap">
    <div class="table-scroll">
      <table>
        <thead>
          <tr>
            <th>Job ID</th>
            <th>Asset</th>
            <th>Type</th>
            <th>Description</th>
            <th>Priority</th>
            <th>Assigned To</th>
            <th>Start Date</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (job of filteredJobs(); track job.id) {
            <tr>
              <td><span class="job-id">{{ job.jobId }}</span></td>
              <td>
                <div class="item-info">
                  <span class="item-icon"><i class="bi" [class]="job.icon ?? 'bi-box-seam'"></i></span>
                  <div>
                    <div class="item-name">{{ job.assetName }}</div>
                    <div class="item-id">{{ job.assetId }}</div>
                  </div>
                </div>
              </td>
              <td><span class="type-badge" [class]="job.type">{{ job.type | titlecase }}</span></td>
              <td>{{ job.description }}</td>
              <td><span class="priority-badge" [class]="job.priority">{{ job.priority | titlecase }}</span></td>
              <td>{{ job.assignedTo }}</td>
              <td>{{ formatDate(job.startDate) }}</td>
              <td><span class="status-badge" [class]="job.status">{{ job.status | titlecase }}</span></td>
              <td class="actions-cell">
                <div class="row-actions">
                  <button type="button" class="btn-action" title="View job" (click)="openViewModal(job)">
                    <i class="bi bi-eye"></i>
                  </button>
                  @if (job.status !== 'completed') {
                    <button type="button" class="btn-action edit" title="Edit job" (click)="openUpdateModal(job)">
                      <i class="bi bi-pencil"></i>
                    </button>
                    <button type="button" class="btn-action delete" title="Delete job" (click)="deleteJob(job)">
                      <i class="bi bi-trash"></i>
                    </button>
                  }
                </div>
                @if (job.status !== 'completed') {
                  <button class="btn btn-success btn-sm" (click)="openCompleteModal(job)">
                    <i class="bi bi-check-lg"></i> Complete
                  </button>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="pagination-bar">
    <div class="pagination-info">
      Showing <span>1</span> to <span>{{ filteredJobs().length }}</span> of <span>{{ filteredJobs().length }}</span> jobs
    </div>
  </div>
</div>

<div class="modal-overlay" [class.open]="showJobModal()" (click)="closeModalOnBackdrop($event)">
  <div class="modal modal-large">
    <div class="modal-header">
      <h2><i class="bi bi-plus-circle"></i> New Maintenance Job</h2>
      <button class="close-btn" (click)="closeJobModal()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="modal-body">
      <div class="form-row">
        <div class="form-group">
          <label>Asset <span class="required">*</span></label>
          <select [ngModel]="formAssetId()" (ngModelChange)="formAssetId.set($event)">
            <option value="">Select Asset</option>
            @for (asset of assets(); track asset.id) {
              <option [value]="asset.id">{{ asset.assetId }} - {{ asset.name }}</option>
            }
          </select>
        </div>
        <div class="form-group">
          <label>Job Type <span class="required">*</span></label>
          <select [ngModel]="formType()" (ngModelChange)="formType.set($event)">
            <option value="repair">Repair</option>
            <option value="maintenance">Maintenance</option>
            <option value="inspection">Inspection</option>
            <option value="service">Service</option>
          </select>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label>Priority <span class="required">*</span></label>
          <select [ngModel]="formPriority()" (ngModelChange)="formPriority.set($event)">
            <option value="low">Low</option>
            <option value="medium">Medium</option>
            <option value="high">High</option>
            <option value="critical">Critical</option>
          </select>
        </div>
        <div class="form-group">
          <label>Sent by <span class="required">*</span></label>
          <input type="text" placeholder="Who sent this to maintenance..." [ngModel]="formSentBy()" (ngModelChange)="formSentBy.set($event)" />
        </div>
        <div class="form-group">
          <label>Responsible for fixing <span class="required">*</span></label>
          <input type="text" placeholder="Technician / vendor..." [ngModel]="formAssignedTo()" (ngModelChange)="formAssignedTo.set($event)" />
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label>Start Date <span class="required">*</span></label>
          <input type="date" [ngModel]="formStartDate()" (ngModelChange)="formStartDate.set($event)" />
        </div>
        <div class="form-group">
          <label>Status</label>
          <select [ngModel]="formStatus()" (ngModelChange)="formStatus.set($event)">
            <option value="pending">Pending</option>
            <option value="in-progress">In Progress</option>
            <option value="on-hold">On Hold</option>
          </select>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group full">
          <label>Description <span class="required">*</span></label>
          <textarea rows="2" placeholder="Describe the maintenance job..." [ngModel]="formDescription()" (ngModelChange)="formDescription.set($event)"></textarea>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn btn-outline" (click)="closeJobModal()">Cancel</button>
      <button class="btn btn-primary" (click)="createJob()">
        <i class="bi bi-check-lg"></i> Create Job
      </button>
    </div>
  </div>
</div>

@if (selectedJob(); as job) {
  <div class="modal-overlay" [class.open]="showViewModal()" (click)="closeModalOnBackdrop($event)">
    <div class="modal">
      <div class="modal-header">
        <h2><i class="bi bi-eye"></i> Job Details</h2>
        <button class="close-btn" (click)="closeViewModal()">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <div class="modal-body">
        <div class="detail-grid">
          <div class="detail-field">
            <label>Job ID</label>
            <span>{{ job.jobId }}</span>
          </div>
          <div class="detail-field">
            <label>Asset</label>
            <span>{{ job.assetId }} - {{ job.assetName }}</span>
          </div>
          <div class="detail-field">
            <label>Type</label>
            <span><span class="type-badge" [class]="job.type">{{ job.type | titlecase }}</span></span>
          </div>
          <div class="detail-field">
            <label>Priority</label>
            <span><span class="priority-badge" [class]="job.priority">{{ job.priority | titlecase }}</span></span>
          </div>
          <div class="detail-field">
            <label>Status</label>
            <span><span class="status-badge" [class]="job.status">{{ job.status | titlecase }}</span></span>
          </div>
          <div class="detail-field">
            <label>Sent by</label>
            <span>{{ job.sentBy || '—' }}</span>
          </div>
          <div class="detail-field">
            <label>Responsible for fixing</label>
            <span>{{ job.assignedTo }}</span>
          </div>
          <div class="detail-field">
            <label>Start Date</label>
            <span>{{ formatDate(job.startDate) }}</span>
          </div>
          <div class="detail-field full">
            <label>Description</label>
            <span>{{ job.description }}</span>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-outline" (click)="closeViewModal()">Close</button>
      </div>
    </div>
  </div>

  <div class="modal-overlay" [class.open]="showUpdateModal()" (click)="closeModalOnBackdrop($event)">
    <div class="modal modal-large">
      <div class="modal-header">
        <h2><i class="bi bi-pencil"></i> Edit Maintenance Job</h2>
        <button class="close-btn" (click)="closeUpdateModal()">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <div class="modal-body">
        <div class="form-row">
          <div class="form-group">
            <label>Job Type <span class="required">*</span></label>
            <select [ngModel]="formType()" (ngModelChange)="formType.set($event)">
              <option value="repair">Repair</option>
              <option value="maintenance">Maintenance</option>
              <option value="inspection">Inspection</option>
              <option value="service">Service</option>
            </select>
          </div>
          <div class="form-group">
            <label>Priority <span class="required">*</span></label>
            <select [ngModel]="formPriority()" (ngModelChange)="formPriority.set($event)">
              <option value="low">Low</option>
              <option value="medium">Medium</option>
              <option value="high">High</option>
              <option value="critical">Critical</option>
            </select>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label>Assigned To <span class="required">*</span></label>
            <input type="text" [ngModel]="formAssignedTo()" (ngModelChange)="formAssignedTo.set($event)" />
          </div>
          <div class="form-group">
            <label>Start Date <span class="required">*</span></label>
            <input type="date" [ngModel]="formStartDate()" (ngModelChange)="formStartDate.set($event)" />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group full">
            <label>Description <span class="required">*</span></label>
            <textarea rows="2" [ngModel]="formDescription()" (ngModelChange)="formDescription.set($event)"></textarea>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label>Status</label>
            <select [ngModel]="formStatus()" (ngModelChange)="formStatus.set($event)">
              <option value="pending">Pending</option>
              <option value="in-progress">In Progress</option>
              <option value="on-hold">On Hold</option>
              <option value="completed">Completed</option>
              <option value="cancelled">Cancelled</option>
            </select>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-outline" (click)="closeUpdateModal()">Cancel</button>
        <button class="btn btn-primary" (click)="updateJob()">
          <i class="bi bi-check-lg"></i> Save Changes
        </button>
      </div>
    </div>
  </div>

  <div class="modal-overlay" [class.open]="showCompleteModal()" (click)="closeModalOnBackdrop($event)">
    <div class="modal">
      <div class="modal-header">
        <h2><i class="bi bi-check-circle"></i> Complete Job</h2>
        <button class="close-btn" (click)="closeCompleteModal()">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <div class="modal-body">
        <div class="confirm-icon success">
          <i class="bi bi-check-circle-fill"></i>
        </div>
        <p class="confirm-text">Mark this job as completed?</p>
        <p class="confirm-subtext">This will update the job status to Completed and add a repair history entry.</p>

        <div class="confirm-details">
          <div class="confirm-row">
            <span class="confirm-label">Job ID:</span>
            <span class="confirm-value">{{ job.jobId }}</span>
          </div>
          <div class="confirm-row">
            <span class="confirm-label">Asset:</span>
            <span class="confirm-value">{{ job.assetId }} - {{ job.assetName }}</span>
          </div>
          <div class="confirm-row">
            <span class="confirm-label">Type:</span>
            <span class="confirm-value">{{ job.type | titlecase }}</span>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-outline" (click)="closeCompleteModal()">Cancel</button>
        <button class="btn btn-success" (click)="completeJob()">
          <i class="bi bi-check-lg"></i> Complete Job
        </button>
      </div>
    </div>
  </div>
}

<div class="toast-container" [class.show]="showToast()">
  <div class="toast success">
    <div class="toast-icon">
      <i class="bi bi-check-circle-fill"></i>
    </div>
    <div class="toast-content">
      <div class="toast-title">Success!</div>
      <div class="toast-message">{{ toastMessage() }}</div>
    </div>
    <button class="toast-close" (click)="closeToast()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>
</div>
